import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';
import { UrlExpanderService } from '../url-expander/url-expander.service';

export const DowngradedSharedDataAccessModelJsModule = angular
  .module('downgraded-shared-data-access-model-js', [])
  .service('UrlExpanderService', downgradeInjectable(UrlExpanderService)).name;
